<script setup lang="ts">
import { computed } from 'vue'

import { useActiveCity } from '~/composables/useActiveCity'
import { usePageSeo } from '~/composables/usePageSeo'
import { usePageOverride } from '~/composables/useRepoApi'

// Региональные H1/SEO главной — из page_city_overrides (pages.slug '/'); без них — московские.
const { data: pageOverride } = await usePageOverride('/')

const seoTitle = computed<string>(
  () => pageOverride.value?.seo_title || 'Ремонт АКПП в Москве, диагностика и продажа АКПП'
)
const seoDescription = computed<string>(
  () =>
    pageOverride.value?.seo_description ||
    'Ремонт АКПП, вариаторов и DSG в Москве. Диагностика, эвакуатор, гарантия, продажа АКПП и подбор решения под марку и модель автомобиля.'
)
const pageH1 = computed<string>(() => pageOverride.value?.h1 || seoTitle.value)
// H2 из региональной версии — заголовок блока преимуществ; пусто — заголовок по умолчанию.
const perksTitle = computed<string | undefined>(() => pageOverride.value?.h2 || undefined)

// Переключатель городов ведёт сюда с ?nopage=1, если такой страницы в регионе нет (T10).
const route = useRoute()
const activeCity = useActiveCity()
const noPageNotice = computed<string>(() => {
  if (route.query.nopage !== '1') {
    return ''
  }

  const cityLocative = activeCity.value?.name_locative?.trim()
  return cityLocative
    ? `Такой страницы ${cityLocative} пока нет — вы на главной странице.`
    : 'Такой страницы в этом городе пока нет — вы на главной странице.'
})

usePageSeo({
  title: seoTitle,
  description: seoDescription,
  type: 'website',
})
</script>

<template>
  <h1 class="sr-only">{{ pageH1 }}</h1>
  <p
    v-if="noPageNotice"
    role="status"
    class="bg-brand-dark text-brand-white px-4 py-3 text-center text-sm">
    {{ noPageNotice }}
  </p>
  <Hero />
  <Section>
    <BrandsGrid baseHref="remont-akpp-" />
    <ServicesSection />
    <RepairQuizBlock />
    <ServiceAndCaseSection />
    <PerksSection :title="perksTitle" />
    <FaqAndReviews :show-on-homepage="true" />
  </Section>
</template>
